import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import HomePage from "./components/HomePage";

function App() {
  return (
    <Router>
      <Routes>

        {/* ✅ Default route redirect */}
        <Route path="/" element={<Navigate to="/dehoga" replace />} />

        {/* ✅ Your main route */}
        <Route path="/dehoga" element={<HomePage />} />

      </Routes>
    </Router>
  );
}

export default App;